module.exports = __webpack_public_path__ + "static/media/branding_1080p_bc.5c5ce0db.png";